export default "__VITE_ASSET__CeQo5a7d__"